export default __webpack_public_path__ + "static/media/claudio-dussin-3.a042e6de.webp";